"use client"

type ErrorPageProps = {
  readonly reset: () => void
}

export default function ErrorPage({ reset }: ErrorPageProps) {
  return (
    <main className="state-main" id="main-content">
      <section className="state-card" role="alert">
        <div aria-hidden="true" className="state-icon state-icon-error">
          <span />
        </div>
        <p className="eyebrow">SAFE RECOVERY</p>
        <h1>페이지를 표시하지 못했습니다</h1>
        <p>입력한 내용은 전송되지 않았습니다. 잠시 후 다시 시도해 주세요.</p>
        <button className="action action-primary" onClick={reset} type="button">
          다시 시도
        </button>
      </section>
    </main>
  )
}
